<header>
  <nav class="d-block p-2 pl-5 pr-5 text-center text-sm-left">

    <!-- Accounting logo -->
    <button class="" id="brand">
      <h1 class="m-0">
        <img [src]="logo || DEFAULT_LOGO" alt="Ottimizza Chamados" height="25px">
      </h1>
    </button>

    <ottimizza-center class="h-100 float-right d-none d-sm-inline-block">
      <div class="mr-4 d-none d-md-inline-block">
        <span class="accounting-name">
          {{ currentUser.organization.name }}
        </span>
        <i class="fas fa-pencil ml-3 cursor-pointer text-dark" (click)="openSiginAsModal()" *ngIf="isAdmin"></i>
      </div>

      <!-- <i class="fal fa-smile mr-4 cursor-pointer text-dark" matTooltip="Avalie-nos" (click)="openNps()"></i> -->
      <!-- <i class="fas fa-exclamation-circle mr-4 cursor-pointer text-dark" matTooltip="Chamados" [matMenuTriggerFor]="tickets"></i> -->
      <i class="fas fa-bell mr-4 cursor-pointer text-dark" matTooltip="Habilitar notificações" (click)="allowNotifications()"></i>

      <a [matMenuTriggerFor]="menu" class="cursor-pointer">
        <img class="img-thumbnail rounded-circle"
          [src]="currentUser.avatar || './assets/images/Portrait_Placeholder.png'" width="45" height="45"
          onError="this.src='./assets/images/Portrait_Placeholder.png';" [alt]="currentUser.firstName">
      </a>
      <div style="position: fixed; right: 67px; top: 36px;"  id="newsletter-container">
      </div>

    </ottimizza-center>


  </nav>
</header>

<div id="bottom-toolbar" class="d-flex d-sm-none justify-content-between p-2 pl-5 pr-5 text-white">
  <a [matMenuTriggerFor]="menu" class="w-100 text-center mt-1">
    <i class="far fa-user-circle" style="font-size: 160%;"></i>
  </a>
  <a (click)="newTicket()" class="w-100 text-center mt-1">
    <i class="far fa-plus-circle" style="font-size: 160%;"></i>
  </a>
  <a (click)="openZpro()" class="w-100 text-center mt-1">
    <i class="far fa-question-circle" style="font-size: 160%;"></i>
  </a>
</div>

<mat-menu #menu="matMenu">
  <a mat-menu-item class="d-sm-none w-100 h-100 text-center">
    <img class="img-thumbnail rounded-circle"
          [src]="currentUser.avatar || './assets/images/Portrait_Placeholder.png'" width="100" height="100"
          onError="this.src='./assets/images/Portrait_Placeholder.png';">
  </a>
  <a [href]="APP_URL + '/dashboard/users/' + currentUser.id" class="dropdown-header dropdown-item text-center mt-0 py-3">
    <h6 class="text-dark overflow-ellipsis m-0">
      {{ currentUser.firstName + ' ' + currentUser.lastName }}
    </h6>
    <small class="text-muted text-lowercase">{{ currentUser.email }}</small>
  </a>
  <!-- <a mat-menu-item (click)="openNps()" class="d-sm-none">
    <i class="far fa-smile" aria-hidden="true"></i>&nbsp;&nbsp;
    <span>Avalie-nos</span>
  </a> -->
  <a mat-menu-item (click)="enableDarkMode()">
    <mat-slide-toggle [checked]="darkMode"></mat-slide-toggle>&nbsp;&nbsp; Modo Escuro
  </a>
  <a mat-menu-item (click)="isAdmin = false" *ngIf="currentUser.type == 0 && isAdmin">
    <i appIcon duotone>user-secret</i>&nbsp;&nbsp;
    <span>Visualizar como Usuário</span>
  </a>
  <a mat-menu-item (click)="allowNotifications()" class="d-sm-none">
    <i appIcon solid>bell</i>&nbsp;&nbsp;
    <span>Habilitar Notificações</span>
  </a>
  <a mat-menu-item [href]="APP_URL + '/dashboard/products/'">
    <i appIcon solid>undo-alt</i>&nbsp;&nbsp;
    <span>Voltar para Aplicativos</span>
  </a>
  <a mat-menu-item (click)="logout()">
    <i appIcon solid>sign-out-alt</i>&nbsp;&nbsp;
    <span>Sair</span>
  </a>
</mat-menu>
